export default{
    baseURL: 'https://servicos.prodb.com.br:8086',
}